import React, { useRef, useMemo } from "react";
import { FlatList, Platform, StyleSheet } from "react-native";
import { Message } from "@/store/types";
import ChatMessage from "./ChatMessage";
import { layout, webScrollbarStyles } from "@/constants";

interface ChatMessagesListProps {
  messages: Message[];
}

export default function ChatMessagesList({ messages }: ChatMessagesListProps) {
  const flatListRef = useRef<FlatList>(null);
  const reversedMessages = useMemo(() => [...messages].reverse(), [messages]);

  return (
    <FlatList
      ref={flatListRef}
      data={reversedMessages}
      inverted
      renderItem={({ item }) => <ChatMessage message={item} />}
      keyExtractor={(item) => item.id}
      style={styles.list}
      contentContainerStyle={styles.contentContainer}
      showsVerticalScrollIndicator={Platform.OS === "web"}
    />
  );
}

const styles = StyleSheet.create({
  list: {
    flex: 1,
    paddingHorizontal: layout.space.lg,
    paddingVertical: layout.space.lg,
    paddingRight: Platform.OS === "web" ? layout.space.md : layout.space.lg,
    ...webScrollbarStyles
  },
  contentContainer: {
    flexGrow: 1,
    justifyContent: "flex-end"
  }
});
